import { useRef, useState } from 'react'
import ImageInput from '../../../core/components/UI/ImageInput'
import {
  useNavigate,
  useParams,
} from 'react-router-dom/dist/umd/react-router-dom.development'
import useMineralsActions from '../../hooks/useMineralsActions'
import { toastSuccess } from '../../../helper'
import { FaSpinner } from 'react-icons/fa'

export default function FormMineralValueChainCreate() {
  const { mineral_id } = useParams()
  const navigate = useNavigate()

  const { createMineralValueChain, inProgress } = useMineralsActions()
  const [mineralValueChainArImage, setMineralValueChainArImage] = useState(null)
  const [mineralValueChainEnImage, setMineralValueChainEnImage] = useState(null)
  const mineralValueChainArSourceRef = useRef(null)
  const mineralValueChainEnSourceRef = useRef(null)
  const mineralValueChainLinkRef = useRef(null)

  // async function handleOnSubmitCreateMineralForm(event) {
  //   event.preventDefault()
  //   const payload = {
  //     image_ar: mineralValueChainArImage,
  //     image_en: mineralValueChainEnImage,
  //     source_ar: mineralValueChainArSourceRef.current?.value,
  //     source_en: mineralValueChainEnSourceRef.current?.value,
  //     link: mineralValueChainLinkRef.current?.value,
  //   }
  //   console.log(payload)

  //   const message = await createMineralValueChain(mineral_id, payload)
  //   if (message) {
  //     toastSuccess(message)
  //     navigate(`/minerals`)
  //   }
  // }


  async function handleOnSubmitCreateMineralForm(event) {
  event.preventDefault()

  const formData = new FormData()
  if (mineralValueChainArImage) formData.append('image_ar', mineralValueChainArImage)
  if (mineralValueChainEnImage) formData.append('image_en', mineralValueChainEnImage)
  formData.append('source_ar', mineralValueChainArSourceRef.current?.value || '')
  formData.append('source_en', mineralValueChainEnSourceRef.current?.value || '')
  formData.append('link', mineralValueChainLinkRef.current?.value || '')

  try {
    const message = await createMineralValueChain(mineral_id, formData)
    if (message) {
      toastSuccess(message)
      navigate(`/minerals`)
    }
  } catch (error) {
    console.error('Erreur lors de la création :', error)
  }
}


  return (
    <form
      onSubmit={handleOnSubmitCreateMineralForm}
      className="flex flex-col gap-4"
    >
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_IMAGE_AR"
          >
            صورة سلسلة القيمة بالعربية<span className="text-danger-600">*</span>
          </label>
          <ImageInput
            id={'ID_MINERAL_IMAGE_AR'}
            onChange={(image) => setMineralValueChainArImage(image)}
            className={'h-96 w-full'}
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_IMAGE_EN"
          >
            صورة سلسلة القيمة بالإنجليزية
          </label>
          <ImageInput
            id={'ID_MINERAL_IMAGE_EN'}
            onChange={(image) => setMineralValueChainEnImage(image)}
            className={'h-96 w-full'}
          />
        </div>
      </div>

      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
          >
            اسم مصدر بالعربية
          </label>
          <input
            id="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
            ref={mineralValueChainArSourceRef}
            type="text"
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_VALUE_CHAIN_EN_SOURCE"
          >
            اسم مصدر بالإنجليزية
          </label>
          <input
            dir="ltr"
            id="ID_MINERAL_VALUE_CHAIN_EN_SOURCE"
            ref={mineralValueChainEnSourceRef}
            type="text"
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="line-clamp-1 font-bold"
          htmlFor="ID_MINERAL_VALUE_CHAIN_AR_SOURCE_REF"
        >
          رابط المصدر
        </label>
        <input
          dir="ltr"
          id="ID_MINERAL_VALUE_CHAIN_AR_SOURCE_REF"
          ref={mineralValueChainLinkRef}
          type="url"
          className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري اضافة سلسلة القيمة...</span>
          </>
        ) : (
          <span>اضافة سلسلة القيمة</span>
        )}
      </button>
    </form>
  )
}























